module.exports = __webpack_public_path__ + "static/media/ic_export.7322b671.svg";